export const validateEndDate =
  (startDateValue: string) =>
  ({ value }: { value: string }) => {
    if (!value) return undefined;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endDate = new Date(value);

    if (endDate < today) {
      return 'A data de fim não pode ser anterior à data atual';
    }

    if (startDateValue) {
      const startDate = new Date(startDateValue);
      if (endDate < startDate) {
        return 'A data de fim não pode ser anterior à data de início';
      }
    }

    return undefined;
  };
